var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopStories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "News",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "News",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11V3h7v7a1 1 0 102 0V2a1 1 0 00-1-1H2a1 1 0 00-1 1v9a4 4 0 004 4h6a4 4 0 004-4V6a1 1 0 10-2 0v5a2 2 0 01-2 2H5a2 2 0 01-2-2z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5a1 1 0 000 2h3a1 1 0 000-2H5zm0 3a1 1 0 000 2h3a1 1 0 000-2H5z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgTopStories;